/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Steps_BodyInputs */

const en_svc_rag_steps_body = /** @type {(inputs: Svc_Rag_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most of the quality comes from the sources and the testing, not from the model.`)
};

const lv_svc_rag_steps_body = /** @type {(inputs: Svc_Rag_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lielākā daļa kvalitātes nāk no avotiem un testēšanas, nevis no modeļa.`)
};

/**
* | output |
* | --- |
* | "Most of the quality comes from the sources and the testing, not from the model." |
*
* @param {Svc_Rag_Steps_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_steps_body = /** @type {((inputs?: Svc_Rag_Steps_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Steps_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_steps_body(inputs)
	return en_svc_rag_steps_body(inputs)
});